import React from 'react';
import {  Row, Col } from 'reactstrap';
import PropTypes from 'prop-types'


const SubmitFailure = ({ clubName }) => (
  <Row >
    <Col md={{ size: 10,offset: 1 }} className="formGroup TextCenter">
      <h2>
        Fout bij versturen
      </h2>
      <p>
        Er is iets misgegaan bij het versturen van het formulier. Probeer het later nog eens of neem contact op met {clubName}.
      </p>
    </Col>
  </Row>
)
SubmitFailure.propTypes = {
  clubName: PropTypes.string.isRequired
}

export default SubmitFailure



// WEBPACK FOOTER //
// ./src/personconsent/SubmitFailure.jsx